import makeService from './api';

export default makeService('product_type_files');
